define([
	'internal_util/LocalizationUtil',
	'internal_util/UiUtil',
	'internal_util/Util',
	'internal_util/Configuration',
	'amdi18n-loader?!view/kiosk/nls/PrivacyPolicyView_strings',
	'lib/jquery'
], function (
	LocalizationUtil,
	UiUtil,
	Util,
	Configuration,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * PrivacyPolicyView class
	 */
	return function (startcallback) {
		var _view = (function () {
			var $privacyPolicyView = 
			    jQuery(
			    "<div id='skIdS_identity-container' class='skIdS_content-body skIdS_column-container' style='height: 100%;'>" +
					    "<div id='skIdS_control-column' class='skIdS_column' style='max-width: 35%;'>" +
						    "<div id='skIdS_identity-button-container'>" +
							"<div id='skIdS_identity-privacy-container' class='skIdS_content-body'>" +
								Strings.privacy_text +
							"</div>" +
						    "</div>" +
					    "</div>" +
					    "<div id='skIdS_control-column' class='skIdS_column' style='max-width: 35%;'>" +
						    "<div id='skIdS_identity-button-container'>" +
							"<div id='skIdS_identity-privacy-container' class='skIdS_content-body'>" +
							    "<div class='ff_pp_container'>" +
								'<label><input id="skIdS_ff_privacy-button" type="checkbox" style="margin: 5px;">' +
								"Ich habe von dem Inhalt der " +
								//'<span style="text-decoration: underline;">Datenschutzerklärung</span>' +
								'<a id="skIds_ff_privacy_url" href="" target="_blank">Datenschutzerklärung</a>' +
                                                                " Kenntnis genommen und willige in die darin beschriebene Verarbeitung meiner Daten ein." +
								'</label>' +
							    "</div>" + 
							    "<div class='ff_pp_container'>" +
							    "Hier geht´s zum eTicket!" + 
							    '<button style="margin-left: 15px;" id="skIdS_ff_start-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							    "</div>" + 
							    '<div style="cursor: pointer;" id="skIdS_ff_pin-button" class="ff_pp_container">' +
							    "Moment, ich muss erst meine Transport-PIN " +
							    '<span style="text-decoration: underline;">ändern.</span>' +
							    '</div>' + 
							"</div>" +
						    "</div>" +
					    "</div>" +
				    "</div>");

			$privacyPolicyView.find('#skIdS_ff_start-button').prop("disabled",true);

			$privacyPolicyView.find('#skIdS_ff_start-button')
			    .text("Start")
			    .on('click', function () {
				if ($privacyPolicyView.find('#skIdS_ff_privacy-button').is(':checked')) {
				    Util.callCallbacks(startcallback);
				}
			    });
			
			$privacyPolicyView.find('#skIdS_ff_pin-button')
			    .on('click', function () {
				var w = window.open("http://localhost:24727/eID-Client?ShowUI=PINManagement");
				setTimeout(function(){
				    w.close();
				},150);
			    });
			
			$privacyPolicyView.find('#skIdS_ff_privacy-button')
			    .change(function() {
				if($privacyPolicyView.find('#skIdS_ff_privacy-button').is(':checked')) {
				    $privacyPolicyView.find('#skIdS_ff_start-button').prop("disabled",false);
				} else {
				    $privacyPolicyView.find('#skIdS_ff_start-button').prop("disabled",true);
				}
			    });

			return $privacyPolicyView;
		})();


		// public methods

		this.get = function () {
			var _tenantUrl = Configuration.get('TENANT_PRIVACY_URL');
			if (!_tenantUrl) {
				Configuration.on('tenantLoaded', function() {
					_tenantUrl = Configuration.get('TENANT_PRIVACY_URL');
					if (!_tenantUrl) {
						console.warn("Missing TENANT_PRIVACY_URL");
					}
					_view.find('#skIds_ff_privacy_url').attr("href", _tenantUrl);
				});
			} else {
				_view.find('#skIds_ff_privacy_url').attr("href", _tenantUrl);
			}
			return _view;
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/kiosk/PrivacyPolicyView.js
// module id = 355
// module chunks = 1